(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1268],{

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 99071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27812);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66261);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Index = function Index(_ref) {
  var links = _ref.links,
      listType = _ref.listType,
      columnGap = _ref.columnGap;

  // ナンバリングのスタート値を計算する
  var setStartValue = function setStartValue(index) {
    var count = 0;
    if (index === 0) return count;

    (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Array(index)).map(function (_, i) {
      return count += links[i].length;
    });

    return count;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
    columnGap: columnGap,
    children: links.map(function (arr, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(List, {
        startValue: setStartValue(index),
        listType: listType,
        as: listType === 'disc' ? 'ul' : '',
        children: arr.map(function (_ref2) {
          var name = _ref2.name,
              anchor = _ref2.anchor;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            "data-list-type": listType,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_scroll__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU, {
              to: anchor,
              smooth: true,
              offset: -105,
              children: name
            })
          }, name);
        })
      }, "".concat(arr.toString()).concat(index));
    })
  });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Index__Wrapper",
  componentId: "sc-12faqix-0"
})(["border:1px solid #707070;padding:30px 33px 25px;display:flex;column-gap:", "px;@media screen and (max-width:1047px){flex-direction:column;padding:30px 20px 27px;}"], function (_ref3) {
  var columnGap = _ref3.columnGap;
  return columnGap;
});
var ListStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["color:", ";counter-increment:number;"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var List = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ol.withConfig */ .ZP.ol.withConfig({
  displayName: "Index__List",
  componentId: "sc-12faqix-1"
})(["letter-spacing:0.32px;counter-reset:", ";li{line-height:26px;letter-spacing:0.3px;&:hover{opacity:0.7;cursor:pointer;}&[data-list-type='number']::before{", ";content:counter(number) '. ';}&[data-list-type='roman']::before{", ";content:counter(number,upper-roman) '. ';}&[data-list-type='article']::before{", ";content:'\u7B2C' counter(number) '\u6761';}&[data-list-type='disc']::before{content:'';width:6px;height:6px;border-radius:50%;background-color:", ";display:inline-block;margin-right:0.5em;transform:translateY(-50%);}}a{color:", ";}@media screen and (max-width:1047px){li{font-size:15px;}}"], function (_ref4) {
  var startValue = _ref4.startValue,
      listType = _ref4.listType;
  return listType !== 'disc' ? "number ".concat(startValue) : '';
}, ListStyle, ListStyle, ListStyle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 68339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ SectionDiv; },
/* harmony export */   "CK": function() { return /* binding */ StyledList; },
/* harmony export */   "JP": function() { return /* binding */ GridTable2; },
/* harmony export */   "Jn": function() { return /* binding */ GridRow; },
/* harmony export */   "R1": function() { return /* binding */ GridTable; },
/* harmony export */   "U5": function() { return /* binding */ SummaryDiv; },
/* harmony export */   "ZB": function() { return /* binding */ ZenkakuSpace; },
/* harmony export */   "_b": function() { return /* binding */ StyledListInGridRow; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "oH": function() { return /* binding */ StyledListItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["color:", ";text-decoration:underline;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var SummaryDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SummaryDiv",
  componentId: "sc-rdu7qb-0"
})(["text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;a{", "}@media screen and (max-width:1047px){font-size:15px;line-height:25px;letter-spacing:0.3px;}"], function (_ref) {
  var color = _ref.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, StyledLink);
var H3Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["font-size:22px;color:", ";font-weight:bold;line-height:30px;letter-spacing:0.88px;@media screen and (max-width:1047px){font-size:15px;letter-spacing:0.6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var StyledH3 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "TextStyle__StyledH3",
  componentId: "sc-rdu7qb-1"
})(["", ""], H3Style);
var SectionDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SectionDiv",
  componentId: "sc-rdu7qb-2"
})(["width:100%;display:flex;flex-direction:column;row-gap:24px;text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;h3{", "}ul{li{max-width:", ";}}ol{padding-left:25px;list-style-type:decimal;}li{span{display:block;font-weight:bold;}}p{span{font-weight:bold;}}a{", "}@media screen and (max-width:1047px){row-gap:30px;font-size:14px;line-height:24px;letter-spacing:0.28px;ul{li{width:100%;}}}"], function (_ref2) {
  var color = _ref2.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, H3Style, function (_ref3) {
  var liWidth = _ref3.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, StyledLink);
var GridTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable",
  componentId: "sc-rdu7qb-3"
})(["width:100%;display:grid;grid-template-columns:25% 25% 25% 25%;grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;@media screen and (max-width:1047px){grid-template-columns:50% 50%;}"]); // カラムが６つのテーブル、テーブル内の文章が単語関係なく改行

var GridTable2 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable2",
  componentId: "sc-rdu7qb-4"
})(["width:100%;display:grid;grid-template-columns:repeat(6,16.6666667%);grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;word-break:break-all;"]);
var GridRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridRow",
  componentId: "sc-rdu7qb-5"
})(["width:100%;display:contents;border-bottom:1px solid #707070;div{border-bottom:1px solid #707070;border-right:1px solid #707070;padding:20px 20px;}@media screen and (max-width:1047px){margin:0px 20px;div{padding:16px 20px 18px;}}"]);
var StyledList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "TextStyle__StyledList",
  componentId: "sc-rdu7qb-6"
})(["counter-reset:number ", ";max-width:", ";margin-left:", ";@media screen and (max-width:1047px){width:100%;margin-left:0;padding-left:", ";}"], function (_ref4) {
  var startValue = _ref4.startValue;
  return startValue === undefined ? '' : startValue;
}, function (_ref5) {
  var liWidth = _ref5.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, function (_ref6) {
  var marginLeft = _ref6.marginLeft;
  return marginLeft === undefined ? '0' : "".concat(marginLeft, "em");
}, function (_ref7) {
  var paddingLeft = _ref7.paddingLeft;
  return paddingLeft === undefined ? '0' : "".concat(paddingLeft, "em");
});
var StyledListInGridRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(StyledList).withConfig({
  displayName: "TextStyle__StyledListInGridRow",
  componentId: "sc-rdu7qb-7"
})(["padding-left:0.8em;"]);
var Article = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var BoldArticle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;font-weight:bold;p{text-indent:0em;font-weight:400;}::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var Disc = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["text-indent:-1em;::before{counter-increment:number;content:'\u30FB';}"]);
var Comment = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-3.5em;::before{counter-increment:number;content:'\uFF08\u6CE8' counter(number) '\uFF09';}@media screen and (max-width:1047px){text-indent:-0.5em;}"]);
var Number = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-1.5em;::before{counter-increment:number;content:counter(number) '. ';}"]);
var StyledListItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "TextStyle__StyledListItem",
  componentId: "sc-rdu7qb-8"
})(["font-weight:400;", " ", ";", ";"], function (_ref8) {
  var listType = _ref8.listType;

  switch (listType) {
    case 'article':
      return Article;

    case 'disc':
      return Disc;

    case 'comment':
      return Comment;

    case 'boldArticle':
      return BoldArticle;

    case 'number':
      return Number;

    case undefined:
      break;
  }
}, function (_ref9) {
  var paddingLeft = _ref9.paddingLeft;
  return paddingLeft && "padding-left:".concat(paddingLeft, "em");
}, function (_ref10) {
  var textIndent = _ref10.textIndent;
  return textIndent && "text-indent:".concat(textIndent, "em");
});
var ZenkakuSpace = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TextStyle__ZenkakuSpace",
  componentId: "sc-rdu7qb-9"
})(["padding-left:", ";"], function (_ref11) {
  var space = _ref11.space;
  return space === undefined ? '1em' : "".concat(space, "em");
});

/***/ }),

/***/ 34371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SNSPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/pages/Legal/TextStyle.tsx
var TextStyle = __webpack_require__(68339);
// EXTERNAL MODULE: ./src/components/elements/LinkText/index.tsx
var LinkText = __webpack_require__(41705);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Legal/SNSPolicy/SNSItems.tsx





var snsItems = [{
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C1\u6761\uFF08\u7DCF\u5247\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u516C\u5F0F\u30A2\u30AB\u30A6\u30F3\u30C8\u5229\u7528\u898F\u7D04\uFF08\u4EE5\u4E0B\u300C\u672C\u898F\u7D04\u300D\u3068\u3044\u3046\uFF09\u306F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\uFF08\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u53CA\u3073\u305D\u306E\u30B0\u30EB\u30FC\u30D7\u4F1A\u793E\u203B\u3092\u3044\u3046\uFF09\u304C\u904B\u55B6\u3059\u308B\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u516C\u5F0F\u30A2\u30AB\u30A6\u30F3\u30C8\u53CA\u3073\u305D\u308C\u306B\u4ED8\u968F\u3059\u308B\u30B5\u30FC\u30D3\u30B9\uFF08\u4EE5\u4E0B\u7DCF\u79F0\u3057\u3066\u300C\u672C\u30B5\u30FC\u30D3\u30B9\u300D\u3068\u3044\u3046\uFF09\u306E\u5229\u7528\uFF08\u5229\u7528\u306B\u306F\u95B2\u89A7\u884C\u70BA\u3082\u542B\u3080\u3002\u4EE5\u4E0B\u540C\u69D8\uFF09\u306B\u3064\u304D\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u8005\uFF08\u4EE5\u4E0B\u300C\u5229\u7528\u8005\u300D\u3068\u3044\u3046\uFF09\u304C\u9075\u5B88\u3059\u3079\u304D\u4E8B\u9805\u3092\u5B9A\u3081\u308B\u3082\u306E\u3067\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u203B\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u30B0\u30EB\u30FC\u30D7\u4F1A\u793E\u306F", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
        path: "/company/overview/",
        text: "\u3053\u3061\u3089"
      }), "\u3067\u3059\u3002"]
    })]
  }),
  id: 'policy1'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C2\u6761\uFF08\u672C\u898F\u7D04\u306E\u7BC4\u56F2\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u898F\u7D04\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u3059\u3079\u3066\u306E\u5229\u7528\u8005\u306B\u9069\u7528\u3055\u308C\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u5229\u7528\u8005\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u305F\u5834\u5408\u3001\u672C\u898F\u7D04\u3092\u627F\u8AFE\u3057\u305F\u3082\u306E\u3068\u307F\u306A\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u30AA\u30F3\u30E9\u30A4\u30F3\u53C8\u306F\u305D\u306E\u4ED6\u306E\u65B9\u6CD5\u3067\u968F\u6642\u63D0\u793A\u3059\u308B\u8AF8\u898F\u5B9A\u306F\u3001\u672C\u898F\u7D04\u306E\u4E00\u90E8\u3092\u69CB\u6210\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002\u305F\u3060\u3057\u3001\u8AF8\u898F\u5B9A\u304C\u672C\u898F\u7D04\u3068\u7570\u306A\u308B\u5834\u5408\u306F\u8AF8\u898F\u5B9A\u304C\u512A\u5148\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u898F\u7D04\u3068\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u63D0\u4F9B\u3057\u305F\u5404\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u904B\u55B6\u4F1A\u793E\u304C\u5B9A\u3081\u3066\u3044\u308B\u5229\u7528\u898F\u7D04\u3084\u65B9\u91DD\u3068\u306E\u9593\u306B\u62B5\u89E6\u304C\u751F\u3058\u305F\u5834\u5408\u3001\u5F53\u8A72\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u904B\u55B6\u4F1A\u793E\u306E\u5229\u7528\u898F\u7D04\u3084\u65B9\u91DD\u306B\u5F93\u3046\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
      })]
    })]
  }),
  id: 'policy2'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C3\u6761\uFF08\u5229\u7528\u8005\u60C5\u5831\u306E\u53D6\u6271\u3044\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: ["\u5229\u7528\u8005\u304C\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306B\u767B\u9332\u3057\u305F\u500B\u4EBA\u60C5\u5831\u306F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u4FDD\u6709\u3057\u3001\u5229\u7528\u8005\u306E\u540C\u610F\u3092\u5F97\u308B\u3053\u3068\u306A\u304F\u7B2C\u4E09\u8005\u306B\u63D0\u4F9B\u3057\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002\u767B\u9332\u3055\u308C\u305F\u500B\u4EBA\u60C5\u5831\u306F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
          path: "/legal/privacy-policy/",
          text: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"
        }), "\u306B\u898F\u5B9A\u3059\u308B\u5229\u7528\u76EE\u7684\u4EE5\u5916\u306B\u306F\u4F7F\u7528\u3057\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u5229\u7528\u8005\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u304A\u3044\u3066\u3001\u3059\u3079\u3066\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u516C\u958B\u3059\u308B\u3068\u8A2D\u5B9A\u3057\u3066\u3044\u308B\u60C5\u5831\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u884C\u3044\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u5229\u7528\u8005\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u305F\u5834\u5408\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u5B9A\u3081\u308B\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC\u306B\u540C\u610F\u3057\u305F\u3082\u306E\u3068\u307F\u306A\u3057\u307E\u3059\u3002"
      })]
    })]
  }),
  id: 'policy3'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C4\u6761\uFF08\u672C\u898F\u7D04\u306E\u5909\u66F4\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u5229\u7528\u8005\u306E\u627F\u8AFE\u306A\u3057\u306B\u3001\u672C\u898F\u7D04\u3092\u5909\u66F4\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002\u5909\u66F4\u5F8C\u306E\u898F\u7D04\u306B\u3064\u3044\u3066\u306F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u3001\u30AA\u30F3\u30E9\u30A4\u30F3\u4E0A\u306B\u8868\u793A\u3057\u305F\u6642\u70B9\u3088\u308A\u3001\u52B9\u529B\u3092\u751F\u3058\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
    })]
  }),
  id: 'policy4'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C5\u6761\uFF08\u7981\u6B62\u4E8B\u9805\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306B\u969B\u3057\u3001\u6B21\u306E\u5404\u53F7\u306B\u8A72\u5F53\u3059\u308B\u884C\u70BA\u3092\u7981\u6B62\u3057\u307E\u3059\u3002"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u3001\u4ED6\u306E\u5229\u7528\u8005\u3001\u7B2C\u4E09\u8005\u306E\u8457\u4F5C\u6A29\u3001\u8096\u50CF\u6A29\u3001\u305D\u306E\u4ED6\u77E5\u7684\u8CA1\u7523\u6A29\u3092\u4FB5\u5BB3\u3059\u308B\u884C\u70BA\u3002\u307E\u305F\u3001\u305D\u306E\u304A\u305D\u308C\u306E\u3042\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u3001\u4ED6\u306E\u5229\u7528\u8005\u3001\u7B2C\u4E09\u8005\u306E\u8CA1\u7523\u3001\u4FE1\u7528\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u7B49\u3092\u4FB5\u5BB3\u3059\u308B\u884C\u70BA\u3002\u307E\u305F\u305D\u306E\u6050\u308C\u306E\u3042\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u771F\u507D\u3092\u554F\u308F\u305A\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u3001\u4ED6\u306E\u5229\u7528\u8005\u3001\u7B2C\u4E09\u8005\u3092\u8AB9\u8B17\u4E2D\u50B7\u3059\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u500B\u4EBA\u60C5\u5831\uFF08\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3001\u4F4F\u6240\u3001\u96FB\u8A71\u756A\u53F7\u3001\u305D\u306E\u4ED6\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u60C5\u5831\uFF09\u3092\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u53CA\u3073\u5F53\u8A72\u500B\u4EBA\u306E\u4E8B\u524D\u306E\u627F\u8AFE\u306A\u304F\u3001\u4ED6\u306E\u5229\u7528\u8005\u3084\u7B2C\u4E09\u8005\u306B\u9001\u4ED8\u3001\u4F1D\u9054\u3001\u958B\u793A\u3001\u8907\u5199\u3001\u66F8\u304D\u8FBC\u307F\u3092\u3059\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u4ED6\u306E\u5229\u7528\u8005\u30FB\u7B2C\u4E09\u8005\u306E\u8457\u4F5C\u7269\u3092\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u4E8B\u524D\u306E\u627F\u8AFE\u306A\u304F\u3001\u4ED6\u306E\u5229\u7528\u8005\u3084\u7B2C\u4E09\u8005\u306B\u9001\u4ED8\u3001\u958B\u793A\u3001\u8907\u5199\u3001\u66F8\u304D\u8FBC\u307F\u3092\u3059\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30A6\u30A3\u30EB\u30B9\u3001\u30CF\u30C3\u30AD\u30F3\u30B0\u7B49\u306B\u3088\u308A\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u904B\u7528\u3092\u59A8\u5BB3\u53C8\u306F\u7834\u58CA\u3059\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u8105\u3057\u3001\u7325\u893B\u3001\u540D\u8A89\u6BC0\u640D\u3001\u5DEE\u5225\u884C\u70BA\u3001\u653F\u6CBB\u6D3B\u52D5\u3001\u5B97\u6559\u6D3B\u52D5\u3001\u53C8\u306F\u305D\u308C\u3089\u306B\u3064\u306A\u304C\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u6C0F\u540D\u3084\u30A2\u30C9\u30EC\u30B9\u3092\u501F\u7528\u3057\u3066\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u306B\u4FB5\u5165\u3059\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u4E8B\u524D\u306E\u8A31\u53EF\u306A\u304F\u55B6\u696D\u6D3B\u52D5\u3001\u4EBA\u6750\u63A1\u7528\u6D3B\u52D5\u3001\u53C8\u306F\u30A2\u30D5\u30A3\u30EA\u30A8\u30A4\u30C8\u3001\u55B6\u696D\u76EE\u7684\u30B5\u30A4\u30C8\u3078\u306E\u8A98\u5C0E\u3001\u30EA\u30F3\u30AF\u7B49\u3001\u55B6\u5229\u3092\u76EE\u7684\u3068\u3057\u3066\u884C\u3046\u4E00\u5207\u306E\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u30B5\u30FC\u30D3\u30B9\u306A\u3044\u3057\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u904B\u7528\u3092\u59A8\u3052\u308B\u884C\u70BA\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u4FE1\u983C\u3092\u6BC0\u640D\u3059\u308B\u884C\u70BA\u3001\u53C8\u306F\u4ED6\u306E\u5229\u7528\u8005\u3082\u3057\u304F\u306F\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306B\u4E0D\u5229\u76CA\u3092\u4E0E\u3048\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u516C\u5E8F\u826F\u4FD7\u306B\u53CD\u3059\u308B\u884C\u70BA\u3001\u72AF\u7F6A\u884C\u70BA\u53C8\u306F\u305D\u308C\u3089\u3068\u5BC6\u63A5\u306B\u95A2\u9023\u3059\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u6CD5\u5F8B\u3001\u6CD5\u4EE4\u9055\u53CD\u53C8\u306F\u305D\u308C\u3089\u306B\u5BC6\u63A5\u306B\u95A2\u9023\u3059\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u7325\u893B\u306A\u6620\u50CF\u30FB\u97F3\u58F0\u30FB\u6587\u5B57\u7B49\u306E\u60C5\u5831\u3092\u63D0\u4F9B\u3059\u308B\u884C\u70BA\u304C\u3042\u3063\u305F\u3001\u3082\u3057\u304F\u306F\u305D\u308C\u3092\u8A66\u307F\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u3042\u3089\u3086\u308B\u7A2E\u985E\u306E\u5E83\u544A\u30D0\u30CA\u30FC\u4EA4\u63DB\u3084\u30EA\u30F3\u30AF\u4EA4\u63DB\u3092\u542B\u3080\u5E83\u544A\u30D0\u30CA\u30FC\u306E\u8868\u793A\u7B49\u306E\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u85AC\u6A5F\u6CD5\u306B\u62B5\u89E6\u3059\u308B\u6050\u308C\u306E\u3042\u308B\u6295\u7A3F\u30FB\u63A8\u5968\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u5404\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u904B\u55B6\u4F1A\u793E\u304C\u7981\u6B62\u3057\u3066\u3044\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u305D\u306E\u4ED6\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u76EE\u7684\u306B\u53CD\u3059\u308B\u884C\u70BA\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u305D\u306E\u4ED6\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u4E0D\u9069\u5207\u3068\u5224\u65AD\u3059\u308B\u884C\u70BA\u3002"
      })]
    })]
  }),
  id: 'policy5'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C6\u6761\uFF08\u7981\u6B62\u884C\u70BA\u306B\u5BFE\u3059\u308B\u63AA\u7F6E\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u6545\u610F\u904E\u5931\u3092\u554F\u308F\u305A\u3001\u5229\u7528\u8005\u304C\u524D\u6761\u5404\u53F7\u306E\u884C\u70BA\u3092\u884C\u3063\u305F\u3001\u53C8\u306F\u884C\u3046\u6050\u308C\u304C\u3042\u308B\u3068\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u5224\u65AD\u3057\u305F\u5834\u5408\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u4E8B\u524D\u306B\u901A\u544A\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u6B21\u306E\u63AA\u7F6E\u306E\u3044\u305A\u308C\u304B\u3001\u53C8\u306F\u8907\u5408\u3055\u305B\u305F\u63AA\u7F6E\u3092\u53D6\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30B3\u30E1\u30F3\u30C8\u7B49\u306E\u66F8\u304D\u8FBC\u307F\u3001\u6295\u7A3F\u5185\u5BB9\u306E\u524A\u9664\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u5236\u9650\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u30DA\u30FC\u30B8\u5185\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u53C8\u306F\u79C1\u4FE1\u30E1\u30FC\u30EB\u3067\u306E\u6CE8\u610F\u30FB\u52E7\u544A\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "(1)\uFF5E(3) \u306E\u51E6\u7F6E\u3092\u8B1B\u3058\u305F\u3053\u3068\u306B\u95A2\u3059\u308B\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u30DA\u30FC\u30B8\u5185\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u53C8\u306F\u79C1\u4FE1\u30E1\u30FC\u30EB\u3067\u306E\u30A2\u30CA\u30A6\u30F3\u30B9\u3002"
      })]
    })]
  }),
  id: 'policy6'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C7\u6761\uFF08\u30B5\uFF0D\u30D3\u30B9\u306E\u5909\u66F4\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u672C\u898F\u7D04\u306E\u307B\u304B\u5225\u9014\u5B9A\u3081\u308B\u500B\u5225\u306E\u898F\u5B9A\u7B49\u306B\u57FA\u3065\u304D\u3001\u5229\u7528\u8005\u306B\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u5229\u7528\u8005\u306E\u627F\u8AFE\u306A\u304F\u3001\u672C\u30B5\uFF0D\u30D3\u30B9\u306E\u5185\u5BB9\u3092\u5909\u66F4\u3059\u308B\uFF08\u6539\u5EC3\u3092\u542B\u3080\uFF09\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"
    })]
  }),
  id: 'policy7'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C8\u6761\uFF08\u77E5\u7684\u8CA1\u7523\u6A29\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306B\u3088\u3063\u3066\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u63D0\u4F9B\u3055\u308C\u308B\u30C6\u30AD\u30B9\u30C8\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3001\u97F3\u697D\u3001\u97F3\u58F0\u3001\u5199\u771F\u3001\u30B0\u30E9\u30D5\u30A3\u30C3\u30AF\u30B9\u3001\u30D3\u30C7\u30AA\u3001\u30DA\u30FC\u30B8\u30EC\u30A4\u30A2\u30A6\u30C8\u3001\u30C7\u30B6\u30A4\u30F3\u3084\u305D\u306E\u4ED6\u306E\u30DE\u30C6\u30EA\u30A2\u30EB\u3092\u542B\u3080\u4E00\u5207\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u4FC2\u308B\u8457\u4F5C\u6A29\u3001\u5546\u6A19\u6A29\u3001\u30B5\u30FC\u30D3\u30B9\u30DE\u30FC\u30AF\u306B\u95A2\u3059\u308B\u6A29\u5229\u3001\u7279\u8A31\u6A29\u3001\u53C8\u306F\u305D\u306E\u4ED6\u306E\u6240\u6709\u6A29\u53CA\u3073\u6CD5\u5F8B\u306B\u3088\u3063\u3066\u4FDD\u8B77\u3055\u308C\u308B\u6A29\u5229\u306F\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306B\u5E30\u5C5E\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
    })]
  }),
  id: 'policy8'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C9\u6761\uFF08\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u5229\u7528\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u5229\u7528\u8005\u304C\u6295\u7A3F\u3057\u305F\u30B3\u30E1\u30F3\u30C8\u30FB\u753B\u50CF\u30FB\u52D5\u753B\u306A\u3069\u306E\u60C5\u5831\u306F\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u672C\u4EBA\u306E\u627F\u8AFE\u3092\u5F97\u308B\u3053\u3068\u306A\u304F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5E83\u544A\u30FB\u5BA3\u4F1D\u3001\u5229\u7528\u4FC3\u9032\u306E\u76EE\u7684\u3067\u3001\u5370\u5237\u7269\u30FB\u4F1A\u5831\u8A8C\u30FB\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u7B49\u306B\u63B2\u8F09\u3059\u308B\u3053\u3068\u3082\u3042\u308A\u307E\u3059\u3002"
    })]
  }),
  id: 'policy9'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C10\u6761\uFF08\u7D1B\u4E89\u306E\u89E3\u6C7A\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u898F\u7D04\u306B\u5B9A\u3081\u306E\u306A\u3044\u4E8B\u9805\u53C8\u306F\u672C\u898F\u7D04\u306E\u89E3\u91C8\u306B\u7591\u7FA9\u304C\u3042\u308B\u5834\u5408\u3001\u3082\u3057\u304F\u306F\u5229\u7528\u8005\u3068\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u9593\u306B\u7D1B\u4E89\u304C\u751F\u3058\u305F\u5834\u5408\u3001\u4FE1\u7FA9\u306B\u5247\u308A\u8AA0\u5B9F\u306B\u3053\u308C\u3092\u89E3\u6C7A\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u5229\u7528\u8005\u3068\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u9593\u3067\u8A34\u8A1F\u306E\u5FC5\u8981\u304C\u751F\u3058\u305F\u5834\u5408\u3001\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u672C\u5E97\u6240\u5728\u5730\u3092\u7BA1\u8F44\u3059\u308B\u88C1\u5224\u6240\u3092\u7B2C\u4E00\u5BE9\u306E\u5C02\u5C5E\u7684\u5408\u610F\u7BA1\u8F44\u88C1\u5224\u6240\u3068\u3057\u307E\u3059\u3002"
      })]
    })]
  }),
  id: 'policy10'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C11\u6761\uFF08\u514D\u8CAC\u4E8B\u9805\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5168\u3066\u306E\u5229\u7528\u8005\u306B\u5BFE\u3057\u3001\u5229\u7528\u8005\u304C\u63D0\u4F9B\u3059\u308B\u5168\u3066\u306E\u60C5\u5831\u306B\u3064\u3044\u3066\u3001\u305D\u306E\u6B63\u78BA\u6027\u3001\u6709\u7528\u6027\u3001\u6700\u65B0\u6027\u3001\u9069\u5207\u6027\u7B49\u305D\u306E\u5185\u5BB9\u306B\u3064\u3044\u3066\u4F55\u3089\u6CD5\u7684\u4FDD\u8A3C\u3092\u3059\u308B\u3082\u306E\u3067\u306F\u306A\u304F\u3001\u4F55\u3089\u306E\u8CAC\u4EFB\u3092\u8CA0\u3046\u3082\u306E\u3067\u3082\u3042\u308A\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u5229\u7528\u8005\u306E\u30D6\u30E9\u30A6\u30B6\u3001\u95B2\u89A7\u74B0\u5883\u306B\u3088\u308A\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306B\u652F\u969C\u304C\u751F\u3058\u308B\u3053\u3068\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u5229\u7528\u8005\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3067\u304D\u306A\u304B\u3063\u305F\u3053\u3068\u306B\u3088\u308A\u751F\u3058\u305F\u640D\u5BB3\u306B\u3064\u3044\u3066\u306F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u4E00\u5207\u306E\u8CAC\u4EFB\u3092\u8CA0\u308F\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u306F\u5916\u90E8\u306E\u6CD5\u4EBA\u306B\u3088\u308A\u904B\u55B6\u3055\u308C\u3066\u3044\u308B\u3082\u306E\u3067\u3042\u308A\u3001\u305D\u306E\u6A5F\u80FD\u3084\u5B89\u5168\u6027\u306B\u3064\u304D\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u4E00\u5207\u306E\u4FDD\u8A3C\u3092\u3059\u308B\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u307E\u305F\u3001\u5916\u90E8\u6CD5\u4EBA\u306E\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u306E\u904B\u7528\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3084\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u6A5F\u80FD\u3001\u3054\u5229\u7528\u65B9\u6CD5\u3084\u6280\u8853\u7684\u306A\u554F\u3044\u5408\u308F\u305B\u306B\u5BFE\u3057\u3066\u306F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u304A\u7B54\u3048\u3044\u305F\u3057\u304B\u306D\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u30B5\u30FC\u30D3\u30B9\u304B\u3089\u30EA\u30F3\u30AF\u3059\u308B\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u4EE5\u5916\u306E\u30B5\u30A4\u30C8\uFF08\u4EE5\u4E0B\u300C\u30EA\u30F3\u30AF\u30B5\u30A4\u30C8\u300D\u3068\u3044\u3046\uFF09\u3092\u5229\u7528\u3055\u308C\u305F\u3053\u3068\u3067\u5229\u7528\u8005\u306B\u751F\u3058\u305F\u640D\u5BB3\u3001\u30EA\u30F3\u30AF\u30B5\u30A4\u30C8\u306E\u5185\u5BB9\u304A\u3088\u3073\u30EA\u30F3\u30AF\u30B5\u30A4\u30C8\u306B\u304A\u3051\u308B\u500B\u4EBA\u60C5\u5831\u306E\u53D6\u308A\u6271\u3044\u306B\u3064\u3044\u3066\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u8CAC\u4EFB\u3092\u8CA0\u3044\u304B\u306D\u307E\u3059\u3002\u30EA\u30F3\u30AF\u30B5\u30A4\u30C8\u304C\u4E2D\u65AD\u3082\u3057\u304F\u306F\u505C\u6B62\u3057\u305F\u3053\u3068\u306B\u3088\u308A\u3001\u5229\u7528\u8005\u304C\u4F55\u3089\u304B\u306E\u640D\u5BB3\u3092\u3053\u3046\u3080\u3063\u305F\u5834\u5408\u3067\u3082\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u4F55\u3089\u306E\u8CAC\u4EFB\u3092\u3082\u8CA0\u308F\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u6295\u7A3F\u30FB\u30B3\u30E1\u30F3\u30C8\u306B\u5BFE\u3057\u3066\u306F\u305D\u306E\u5168\u3066\u306B\u8FD4\u4FE1\u3059\u308B\u308F\u3051\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u516C\u5F0F\u767A\u8868\u30FB\u898B\u89E3\u306E\u767A\u4FE1\u306F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u53CA\u3073\u30CB\u30E5\u30FC\u30B9\u30EA\u30EA\u30FC\u30B9\u7B49\u3067\u884C\u3063\u3066\u3044\u307E\u3059\u3002\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u53CA\u3073\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u793E\u54E1\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u3066\u767A\u4FE1\u3059\u308B\u60C5\u5831\u306B\u3064\u3044\u3066\u306F\u3001\u5FC5\u305A\u3057\u3082\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u516C\u5F0F\u767A\u8868\u30FB\u898B\u89E3\u3092\u8868\u3059\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u307E\u305F\u3001\u5229\u7528\u8005\u306B\u3088\u3063\u3066\u6295\u7A3F\u3055\u308C\u305F\u30E6\u30FC\u30B6\u30FC\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u3068\u305D\u306E\u5F93\u696D\u54E1\u3084\u95A2\u4FC2\u8005\u306E\u610F\u898B\u3084\u7406\u60F3\u3092\u53CD\u6620\u3057\u3066\u3044\u308B\u308F\u3051\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u304A\u3051\u308B\u6587\u8A00\u3084\u4E3B\u5F35\u306E\u6B63\u78BA\u6027\u3092\u4FDD\u8A3C\u3059\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u5229\u7528\u8005\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u3066\u63B2\u8F09\u3057\u305F\u5168\u3066\u306E\u60C5\u5831\u306B\u3064\u3044\u3066\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u4E0D\u9069\u5207\u3068\u5224\u65AD\u3057\u305F\u5834\u5408\u306B\u306F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u5F53\u8A72\u5229\u7528\u8005\u306B\u5BFE\u3057\u3066\u7406\u7531\u3092\u958B\u793A\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u88C1\u91CF\u306B\u3066\u3001\u5F53\u8A72\u60C5\u5831\u306E\u524A\u9664\u3092\u884C\u3046\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u305F\u3060\u3057\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u672C\u9805\u306E\u898F\u5B9A\u3092\u3082\u3063\u3066\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u5229\u7528\u8005\u304C\u63B2\u8F09\u3059\u308B\u60C5\u5831\u306E\u76E3\u8996\u53CA\u3073\u691C\u67FB\u3092\u884C\u3046\u3053\u3068\u3092\u4F55\u3089\u4FDD\u8A3C\u3059\u308B\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u5229\u7528\u8005\u306B\u3088\u308B\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306B\u8D77\u56E0\u53C8\u306F\u95A2\u9023\u3057\u3066\u5229\u7528\u8005\u304C\u4ED6\u306E\u5229\u7528\u8005\u53C8\u306F\u7B2C\u4E09\u8005\u306B\u53CA\u307C\u3057\u305F\u640D\u5BB3\u3001\u53CA\u3073\u7B2C\u4E09\u8005\u306B\u3088\u308B\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u95B2\u89A7\u306B\u8D77\u56E0\u53C8\u306F\u95A2\u9023\u3057\u3066\u7B2C\u4E09\u8005\u304C\u5229\u7528\u8005\u306B\u53CA\u307C\u3057\u305F\u640D\u5BB3\uFF08\u60AA\u610F\u3092\u6301\u3063\u305F\u7B2C\u4E09\u8005\u304C\u4F55\u3089\u304B\u306E\u65B9\u6CD5\u3067\u500B\u4EBA\u60C5\u5831\u3092\u53CE\u96C6\u3057\u3001\u305D\u306E\u3053\u3068\u306B\u3088\u3063\u3066\u3001\u5229\u7528\u8005\u304C\u640D\u5BB3\u3092\u88AB\u3063\u305F\u5834\u5408\u3092\u542B\u3080\uFF09\u306B\u3064\u3044\u3066\u3001\u4E00\u5207\u306E\u8CAC\u4EFB\u3092\u8CA0\u308F\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u5229\u7528\u8005\u306B\u5BFE\u3057\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u54C1\u8CEA\u53C8\u306F\u6027\u80FD\u306B\u3064\u3044\u3066\u306F\u5982\u4F55\u306A\u308B\u4FDD\u8A3C\u3082\u884C\u3044\u307E\u305B\u3093\u3002\u307E\u305F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u5229\u7528\u8005\u306B\u5BFE\u3057\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u4E00\u6642\u505C\u6B62\u3001\u4E2D\u6B62\u3001\u6B20\u9665\u53CA\u3073\u305D\u308C\u3089\u306B\u8D77\u56E0\u53C8\u306F\u95A2\u9023\u3057\u3066\u767A\u751F\u3057\u305F\u5168\u3066\u306E\u640D\u5931\u3084\u640D\u5BB3\u306B\u3064\u3044\u3066\u306F\u3001\u4E00\u5207\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u4E8B\u524D\u306B\u30AA\u30F3\u30E9\u30A4\u30F3\u4E0A\u306B\u3066\u544A\u77E5\u3092\u884C\u3063\u305F\u4E0A\u3067\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u4E00\u90E8\u3082\u3057\u304F\u306F\u5168\u3066\u3092\u7D42\u4E86\u3057\u3001\u30C7\u30FC\u30BF\u3092\u6D88\u53BB\u3059\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u7D42\u4E86\u306B\u3088\u308A\u5229\u7528\u8005\u53CA\u3073\u7B2C\u4E09\u8005\u304C\u88AB\u3063\u305F\u88AB\u5BB3\u306B\u3064\u3044\u3066\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u514D\u8CAC\u3055\u308C\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
      })]
    })]
  }),
  id: 'policy11'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["\u5236\u5B9A\u65E5", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* ZenkakuSpace */.ZB, {}), "2020\u5E747\u670823\u65E5", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u6700\u7D42\u6539\u5B9A\u65E5", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* ZenkakuSpace */.ZB, {}), "2022\u5E7412\u670826\u65E5"]
    })
  }),
  id: 'signdate'
}];
var snsLinks = [[{
  name: '（総則）',
  anchor: 'policy1'
}, {
  name: '（本規約の範囲）',
  anchor: 'policy2'
}, {
  name: '（利用者情報の取扱い）',
  anchor: 'policy3'
}], [{
  name: '（本規約の変更）',
  anchor: 'policy4'
}, {
  name: '（禁止事項）',
  anchor: 'policy5'
}, {
  name: '（禁止行為に対する措置）',
  anchor: 'policy6'
}], [{
  name: '（サ－ビスの変更）',
  anchor: 'policy7'
}, {
  name: '（知的財産権）',
  anchor: 'policy8'
}, {
  name: '（トライアルグループの利用）',
  anchor: 'policy9'
}], [{
  name: '（紛争の解決）',
  anchor: 'policy10'
}, {
  name: '（免責事項）',
  anchor: 'policy11'
}]];
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Legal/Index/index.tsx
var Index = __webpack_require__(99071);
;// CONCATENATED MODULE: ./src/components/pages/Legal/SNSPolicy/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var sectionTitle = {
  titleText: 'Social Media Policy',
  subTitleText: 'トライアルグループ ソーシャルメディア公式アカウント利用規約'
};
var SNSPage = function SNSPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "SNS\u30DD\u30EA\u30B7\u30FC",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306ESNS\u30DD\u30EA\u30B7\u30FC\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        type: 'article',
        url: 'legal/sns-policy/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SnsContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CompleteTitle, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          color: "normal",
          titleText: sectionTitle.titleText,
          subTitleText: sectionTitle.subTitleText
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 60
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Index/* Index */.g, {
        columnGap: 25,
        listType: "article",
        links: snsLinks
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 39
        }
      }), snsItems.map(function (_ref, index) {
        var children = _ref.children,
            id = _ref.id;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SectionDiv */.$V, {
            id: id,
            children: children
          }), index < snsItems.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              pc: 70,
              sp: 39
            }
          })]
        }, "".concat(id).concat(index));
      })]
    })]
  });
};

SNSPage.getLayout = function (page) {
  var pageTitle = {
    title: 'Legal',
    subTitle: '法務'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '法務',
    path: '/legal/'
  }, {
    name: 'SNSポリシー',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: false,
    children: page
  }));
};

var SnsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SNSPolicy__SnsContainer",
  componentId: "sc-1a3jqc4-0"
})(["width:1040px;padding-top:62px;padding-bottom:130px;margin:0 auto;@media screen and (max-width:1047px){width:100%;padding:40px 20px 70px;}"]);
var CompleteTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SNSPolicy__CompleteTitle",
  componentId: "sc-1a3jqc4-1"
})(["width:100%;margin:0 auto;@media screen and (max-width:1047px){max-width:200px;}"]);
;// CONCATENATED MODULE: ./src/pages/legal/sns-policy.tsx


/***/ }),

/***/ 32034:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/sns-policy",
      function () {
        return __webpack_require__(34371);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,5548,9774,2888,179], function() { return __webpack_exec__(32034); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);